"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Container = exports.Category = void 0;
var _mui = require("@ori-ui/mui");
const Category = exports.Category = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        borderBottom: "1px solid ".concat(theme.palette.grey[200])
    };
});
const Container = exports.Container = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        gap: theme.spacing(3),
        width: '100%',
        flexWrap: 'wrap',
        marginBottom: theme.spacing(3)
    };
});
